var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVatican(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fddf00",
    d: "M0 24V0h15v24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#a1a1a1",
    d: "m26.82 8.24.33-.62-.68.31z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#a1a1a1",
    d: "M26.85 7.68a.25.25 0 1 0 .5 0 .25.25 0 0 0-.5 0m-.58.15c-.11.11-.06.36.13.55s.44.24.55.13c.12-.12.06-.36-.13-.55s-.43-.25-.55-.13"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#cb9c2b",
    d: "M20.56 13.56c.38.36.7-.1 1.3-.64.56-.49 4.2-3.87 4.59-4.21.39-.35.02-.87-.43-.45-.45.43-4.8 4.07-5.13 4.37-.32.3-.75.53-.33.93"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#cb9c2b",
    d: "m26.35 8.56.44.49-.22.19.22.18.21-.18.32.34v.34l-.61.52-.36-.24v-.28h-.3v.27l.16.01.14.16.01.36-.54.44-1.1-1.05zm-8.69 6.1a1.5 1.5 0 1 0 2.98.09 1.5 1.5 0 0 0-2.98-.09m.95 0a.49.49 0 1 1 .5-.48h.04a.49.49 0 0 1 .98 0 .5.5 0 0 1-.49.48.49.49 0 1 1-.5.49h-.03a.49.49 0 0 1-.98 0 .5.5 0 0 1 .48-.49"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#a1a1a1",
    d: "M20.12 13.25c-.11.11-.05.36.13.55.2.18.44.24.55.13.12-.12.06-.36-.13-.55s-.43-.25-.55-.13m-2.4.19a.26.26 0 1 0 .52 0 .26.26 0 0 0-.51 0m2.23 2.46a.26.26 0 1 0 .51 0 .26.26 0 0 0-.5 0m-2.29-.09a.26.26 0 1 0 .51 0 .26.26 0 0 0-.5 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4b4b5",
    d: "M24.77 11.08a1 1 0 0 0 .32-.37c.3-.65-.07-1.7-.3-2.1-.28-.5-.1-.82.02-.98l-.13-.02q-.16 0-.3.15c-.3.31-.16.73.24 1.67.31.71.43 1.22.15 1.65"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4b4b5",
    d: "M24.21 8.04a.7.7 0 0 1 .63-.32q.34 0 .64.23l.28-.43c-.12-.1-.42-.31-.76-.31l-.26.04c-.38.14-.51.49-.53.8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#cb9c2b",
    d: "m18.18 8.24-.32-.62.67.31z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#cb9c2b",
    d: "M18.16 7.68a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m.57.15c.12.11.06.36-.13.55s-.44.24-.55.13c-.12-.12-.06-.36.13-.55s.43-.25.55-.13"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#a1a1a1",
    d: "M24.44 13.56c-.38.36-.7-.1-1.3-.64-.56-.49-4.2-3.87-4.58-4.21-.4-.35-.03-.87.42-.45.45.43 4.8 4.07 5.13 4.37.32.3.75.53.33.93"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#a1a1a1",
    d: "m18.65 8.56-.43.49.21.19-.21.18-.22-.18-.32.34v.34l.61.52.36-.24v-.28h.3v.27l-.16.01-.14.16-.01.36.54.44 1.1-1.05zm7.2 4.61a1.5 1.5 0 1 0-.08 2.99 1.5 1.5 0 0 0 .08-2.99m1.02 1.98a.49.49 0 0 1-.98 0h-.04a.49.49 0 0 1-.97 0c0-.27.21-.48.48-.49a.49.49 0 1 1 0-.97c.27 0 .5.22.5.48l.03.01a.49.49 0 1 1 .5.48c.26 0 .48.22.48.49"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#cb9c2b",
    d: "M24.88 13.25c.12.11.06.36-.13.55-.19.18-.44.24-.55.13-.12-.12-.06-.36.13-.55s.43-.25.55-.13m2.4.19a.26.26 0 1 1-.52 0 .26.26 0 0 1 .51 0m-2.22 2.46a.26.26 0 1 1-.51 0 .26.26 0 0 1 .51 0m2.3-.09a.26.26 0 1 1-.52 0 .26.26 0 0 1 .51 0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23.92 7.72c0 1.47-.64 1.43-1.43 1.43s-1.43.04-1.43-1.43.64-3.05 1.43-3.05 1.43 1.58 1.43 3.05"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.43 9.05c-.43 0-.72-.02-.93-.17q-.34-.26-.34-1.16c0-1.5.66-2.95 1.33-2.95s1.33 1.46 1.33 2.95c0 1.33-.53 1.33-1.2 1.33z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#cb9c2b",
    d: "M23.24 8.04c-.5-.14-.42-.62-.75-.62s-.24.48-.74.62-.75-.08-.75-.08l.23.96s.42-.36 1.26-.36 1.26.36 1.26.36l.23-.96s-.24.23-.74.08"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#cb9c2b",
    d: "M23.32 6.78c-.56-.16-.47-.66-.83-.66s-.27.5-.83.66c-.55.15-.82-.1-.82-.1l.25 1.02s.47-.38 1.4-.38 1.4.38 1.4.38l.26-1.01s-.28.24-.83.08"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#cb9c2b",
    d: "M23.19 5.45c-.47-.13-.4-.56-.7-.56s-.23.43-.7.56c-.46.12-.7-.08-.7-.08l.23.85S21.7 6 22.49 6s1.18.23 1.18.23l.22-.85s-.24.2-.7.08m-.88-.95c0 .15.08.27.18.27s.18-.12.18-.27-.08-.27-.18-.27-.18.12-.18.27"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#cb9c2b",
    d: "M22.04 4.2c0 .1.2.2.45.2s.45-.1.45-.2-.2-.18-.45-.18-.45.08-.45.19"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#cb9c2b",
    d: "M22.31 3.94q.01.16.18.18a.2.2 0 0 0 .18-.19.2.2 0 0 0-.18-.18.2.2 0 0 0-.18.19"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4b4b5",
    d: "M20.21 11.08a1 1 0 0 1-.31-.37c-.3-.65.07-1.7.3-2.1.27-.5.1-.82-.03-.98l.13-.02q.16 0 .31.15c.3.31.16.73-.25 1.67-.3.71-.43 1.22-.15 1.65"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4b4b5",
    d: "M20.77 8.04a.7.7 0 0 0-.63-.32q-.34 0-.64.23l-.28-.43c.13-.1.43-.31.76-.31q.14 0 .26.04c.38.14.51.49.53.8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec1c24",
    d: "M22.49 11c.2.15.25.75.25 1.45v5.49s.3.07.21.89c-.03.23-.48.19-.56 0s-.04-.8.1-.88V12.5c0-.81-.13-1.13-.18-1.28s.08-.3.18-.22"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec1c24",
    d: "M24.38 14.8c-.2-.14-.47-.48-.71-.81-.31-.44-.4-.74-.7-1.11-.31-.38-1.12-1.16-1.32-1.13-.07.01-.15.19-.08.25s.3.31.82.7c.51.4.6.83 1.02 1.46.4.57.74.97 1.05 1.02z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec1c24",
    d: "M23.36 11.55c-.18.18-.75.73-1.06 1.09-.3.36-.7 1.22-1.04 1.61a4 4 0 0 1-.64.6 2 2 0 0 1-.1.39c.25-.09.6-.32 1.05-.96.61-.89.9-1.54 1.2-1.8.3-.24.42-.32.59-.5s.19-.6 0-.43"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec1c24",
    d: "M22.13 12.28v5.78c-.34.27-.24.7-.18.93.06.21.6.21.69.1s.1-.84-.2-1.09v-5.36c0-.14-.32-.57-.32-.36"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec1c24",
    d: "M20.1 14.98c-.3.21-.56.57.1.83.67.27 1.55.63 2.3.63.73 0 2.11-.5 2.44-.73.32-.23.46-.5-.05-.65-.28-.08-.32.13-.18.17s.31.2-.05.33c-.35.13-1.16.5-2.23.5-1.06 0-2.06-.44-2.22-.5s-.21-.25-.1-.33c.12-.07.12-.34-.02-.25"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#cb9c2b",
    d: "M22.86 17.76a.21.21 0 1 1-.43.03.21.21 0 0 1 .43-.03"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#cb9c2b",
    d: "M22.5 17.9a.21.21 0 0 1-.41.09l-.01-.09a.21.21 0 0 1 .42 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVatican);
export default __webpack_public_path__ + "static/media/vatican.5200737b5d59737b2b56d188344d5918.svg";
export { ForwardRef as ReactComponent };